"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.costInvoicesRepository = exports.PaymentStatuses = exports.CostInvoiceApiError = void 0;
exports.syncFromKsef = syncFromKsef;
exports.fetchCostInvoiceDetails = fetchCostInvoiceDetails;
exports.fetchCostInvoiceQr = fetchCostInvoiceQr;
exports.updateCostInvoice = updateCostInvoice;
exports.checkWhiteList = checkWhiteList;
exports.fetchCostInvoiceReparsePreview = fetchCostInvoiceReparsePreview;
exports.applyCostInvoiceReparse = applyCostInvoiceReparse;
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
class CostInvoiceApiError extends Error {
    constructor(message, options) {
        super(message);
        this.name = "CostInvoiceApiError";
        this.status = options?.status;
        this.payload = options?.payload;
    }
}
exports.CostInvoiceApiError = CostInvoiceApiError;
async function throwCostInvoiceApiError(response, fallbackMessage) {
    let payload;
    try {
        payload = (await response.json());
    }
    catch {
        payload = undefined;
    }
    const message = payload?.error ||
        payload?.message ||
        payload?.errorMessage ||
        `${fallbackMessage} (${response.status})`;
    throw new CostInvoiceApiError(message, {
        status: response.status,
        payload,
    });
}
/**
 * Statusy płatności faktur kosztowych
 */
exports.PaymentStatuses = {
    UNPAID: "UNPAID",
    PARTIALLY_PAID: "PARTIALLY_PAID",
    PAID: "PAID",
    NOT_APPLICABLE: "NOT_APPLICABLE",
};
/**
 * Repozytorium faktur kosztowych
 * Dane pobierane z KSeF i przechowywane lokalnie
 */
exports.costInvoicesRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "cost-invoices",
        addNewRoute: "cost-invoices",
        editRoute: "cost-invoices",
        deleteRoute: "cost-invoices",
    },
    name: "costInvoices",
});
/**
 * Synchronizacja faktur z KSeF
 */
async function syncFromKsef(params) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices/sync`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        await throwCostInvoiceApiError(response, "Błąd synchronizacji");
    }
    return response.json();
}
/**
 * Pobiera szczegóły pojedynczej faktury
 */
async function fetchCostInvoiceDetails(id) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices/${id}`, {
        method: "GET",
        credentials: "include",
    });
    if (!response.ok) {
        await throwCostInvoiceApiError(response, "Błąd pobierania szczegółów faktury");
    }
    const result = await response.json();
    return result.data || result;
}
/**
 * Pobiera dane QR dla faktury kosztowej (KSeF)
 */
async function fetchCostInvoiceQr(id) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices/${id}/qr`, {
        method: "GET",
        credentials: "include",
    });
    if (!response.ok) {
        await throwCostInvoiceApiError(response, "Błąd pobierania danych QR");
    }
    const result = await response.json();
    return result.data || result;
}
/**
 * Aktualizuje dane faktury edytowalne ręcznie: notatkę i stan płatności
 */
async function updateCostInvoice(id, data) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices/${id}`, {
        method: "PATCH",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        await throwCostInvoiceApiError(response, "Błąd aktualizacji faktury");
    }
    const result = await response.json();
    return result.data || result;
}
/**
 * NIP-K2 — ręczna (re-)weryfikacja Białej Listy VAT (KAS wl-api) dla faktury kosztowej.
 * Nadpisuje poprzedni wynik (whiteListStatus/whiteListRequestId/whiteListCheckedAt) —
 * backend przechowuje tylko ostatni. Domyślnie sprawdza na dziś (bez `date` w body).
 * Backend: PS-nodeJS POST /cost-invoices/:id/white-list/check
 */
async function checkWhiteList(id, date) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices/${id}/white-list/check`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(date ? { date } : {}),
    });
    if (!response.ok) {
        await throwCostInvoiceApiError(response, "Błąd weryfikacji Białej Listy");
    }
    const result = await response.json();
    return result.data || result;
}
/**
 * Podgląd zmian reparse (nagłówek faktury, bez pozycji)
 */
async function fetchCostInvoiceReparsePreview() {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices/reparse-preview`, {
        method: "POST",
        credentials: "include",
    });
    if (!response.ok) {
        await throwCostInvoiceApiError(response, "Błąd podglądu reparse");
    }
    const result = await response.json();
    return result.data || result;
}
/**
 * Zastosuj reparse dla wybranych faktur
 */
async function applyCostInvoiceReparse(ids) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices/reparse-apply`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ ids }),
    });
    if (!response.ok) {
        await throwCostInvoiceApiError(response, "Błąd zastosowania reparse");
    }
    const result = await response.json();
    return result.data || result;
}
